// extracted by mini-css-extract-plugin
module.exports = {"top":"HeaderNavigation_top__NJ2Af"};